const AppConstatnts = {
  DRAFTCOMBINE_EVENT_ID: "09",
  GLEAGUE_ELITE_CAMP_EVENT_ID: "21",
  DRAFTCOMBINE_EVENT_NAME: "NBA Draft Combine",
  GLEAGUE_ELITE_CAMP_EVENT_NAME: "G League Elite Camp",

  BALLOT_VOTE: {
    NBA_DRAFTCOMBINE_BALLOT_VOTE_EVENT_ID: "09",
    NBA_DRAFTCOMBINE_GREEN_BALLOT_VOTE_EVENT_ID: "03",
    NBA_DRAFTCOMBINE_TOP_FIVE_BALLOT_VOTE_EVENT_ID: "05",
    BALLOT_VOTE_EVENT_HEADING_MSG:
      "The event is disabled. Contact admin or click home to proceed",
  },

  VALIDATIONS: {
    EMAIL_REGEX:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    NOT_DECIMAL_REGEX: /\D/g,
    NO_LETTERS_OR_SPECIAL_CHARS: /[a-zA-Z`~!@#$%^&*_=-><?()/+:;"'{}|\\[\]]/g,
    YEAR_REGEX: /^(?:\d{4}|\d{4}-\d{2}|\d{4}-\d{4})$/,
  },
};

export default AppConstatnts;
